import { useDriverTip } from 'packages/shared/checkout/hooks/useDriverTip';
import React from 'react';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import DriverTipBox from '../TipBox';

type DisplayType = {
  $displaytype?: 'row' | 'column';
};

const StyledRow = styled(Row)<DisplayType>`
  gap: 5px;
  flex-wrap: nowrap;
  justify-content: space-between;
  ${({ $displaytype }) =>
    $displaytype === 'column' &&
    `
    display: block;
  `}
`;

const StyledH2 = styled.h2<DisplayType>`
  color: ${({ theme }) => theme.text.color};
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 0;
  text-wrap: nowrap;

  ${({ $displaytype }) =>
    $displaytype === 'column' &&
    `
     margin-bottom: 12px;
  `}
`;

const TipBoxContainer = styled.div<DisplayType>`
  overflow-x: auto;
  display: flex;
  gap: 5px;
  padding: 5px; /* Add padding */
  cursor: pointer; /* Change cursor to pointer */
  scroll-behavior: smooth; /* Add smooth scrolling behavior */

  ${({ $displaytype }) =>
    $displaytype === 'column' &&
    `
    padding: unset;
  `}
`;

interface Props {
  displayType?: 'row' | 'column';
  showNotNow?: boolean;
}

const DriverTip: React.FC<Props> = ({ displayType = 'row', showNotNow }) => {
  const { t } = useTranslation();
  const { handleTipSelection, driverTip } = useDriverTip();

  return (
    <StyledRow $displaytype={displayType} noGutters className="mb-5 align-items-center justify-content-between">
      <StyledH2 $displaytype={displayType}>{t('newOrderPage.tipDriver')}</StyledH2>
      <TipBoxContainer $displaytype={displayType}>
        {showNotNow && <DriverTipBox displayType={displayType} tip={0} onSelected={handleTipSelection} isSelected={driverTip === 0} />}
        <DriverTipBox displayType={displayType} tip={3} onSelected={handleTipSelection} isSelected={driverTip === 3} />
        <DriverTipBox displayType={displayType} tip={5} onSelected={handleTipSelection} isSelected={driverTip === 5} />
        <DriverTipBox displayType={displayType} tip={10} onSelected={handleTipSelection} isSelected={driverTip === 10} />
      </TipBoxContainer>
    </StyledRow>
  );
};

export default DriverTip;
